<template>
  <div :class="['dropdown', isOpen ? 'dropdown--open' : '']" @click="open">
    <slot name="button"></slot>
    <slot name="submenu"></slot>
  </div>
</template>

<script>

export default {
  data() {
		return {
			isOpen: false,
		}
	},
  methods: {
    open: function(){
      this.isOpen = true;
    },
    documentClick(e){
      let el = this.$el
      let target = e.target
      if ( el !== target && !el.contains(target)) {
        this.isOpen = false;
      }
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  }
}
</script>
